export default "__VITE_ASSET__6a49ce92__$_?component__"